import { useHealthblocksSWR, useSubjectId } from '@healthblocks-io/core'

import type { HealthProfile } from '../types/HealthProfile.types'

/**
 * Fetches health data from Healthblocks and Synops
 * @returns the health profile
 */
export function useHealthProfile() {
  const subjectId = useSubjectId()
  const queryParameters = new URLSearchParams()

  if (subjectId) {
    queryParameters.append('subjectId', String(subjectId))
  }

  const queryString = queryParameters.toString()

  return useHealthblocksSWR<HealthProfile>(
    `/views/patient/health-profile/general${queryString ? `?${queryString}` : ''}`,
    {
      revalidateOnMount: true,
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
      revalidateIfStale: true,
    },
  )
}
